import * as React from 'react'
import '../styles/App.scss'
import { RouterAction } from 'react-router-redux'
import { AddressInfo } from '../types'
import FormattedAddress from './FormattedAddress'
import { ROUTES } from '../constants/routes'
import { StringResources } from '../localization/StringResources'
import { Strings } from '../localization'

interface PickupLocationInfoProps {
	routePush: (location: string) => RouterAction
	address?: AddressInfo
}

class PickupLocationInfo extends React.Component<PickupLocationInfoProps, {}> {

	handleClick = (e: any) => {
		if (e.key === 'Enter' || e.key === ' ' || e.key === undefined) {
			this.props.routePush(ROUTES.PICKUP_LOCATION)
		}
	}

	render() {
		return (
			<div className="Pickup-info" >
				<div className="title">{StringResources.getString(Strings.Components.PickupLocationInfo.Title)}</div>
				<div
					className="list list-contant change-location"
					onClick={this.handleClick}
					onKeyDown={this.handleClick}
					title={StringResources.getString(Strings.Components.PickupLocationInfo.Buttons.ChangeLocation.label)}
				>
					<FormattedAddress
						address={this.props.address ? this.props.address : {}}
					/>
				</div>
			</div>
		)
	}
}

export default PickupLocationInfo



// WEBPACK FOOTER //
// ./src/components/PickupLocationInfo.tsx